import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { Badge } from '@/components/ui/badge'
import { Label } from '@/components/ui/label'
import { useFormContext } from 'react-hook-form'
import { SCOPE_CATEGORIES } from '@/constants/scope-categories'

interface ScopeSelectorProps {
  name: string
}

export function ScopeSelector({ name }: ScopeSelectorProps) {
  const { setValue } = useFormContext()

  const handleCategoryChange = (categoryId: string) => {
    const category = SCOPE_CATEGORIES.find(c => c.id === categoryId)
    if (category) {
      setValue('scopes', JSON.stringify(category.scopes))
    }
  }

  return (
    <FormField
      name={name}
      render={({ field }) => (
        <FormItem className="space-y-3">
          <FormLabel>Scope Category</FormLabel>
          <FormControl>
            <RadioGroup
              value={field.value}
              onValueChange={(value) => {
                field.onChange(value)
                handleCategoryChange(value)
              }}
              className="space-y-3"
            >
              {SCOPE_CATEGORIES.map((category) => {
                const displayScopes = category.scopes.slice(0, 3)
                const remainingCount = category.scopes.length - 3

                return (
                  <div
                    key={category.id}
                    className="flex items-start space-x-3 space-y-0 rounded-md border p-4"
                  >
                    <RadioGroupItem value={category.id} id={category.id} />
                    <div className="flex-1">
                      <Label
                        htmlFor={category.id}
                        className="font-medium cursor-pointer"
                      >
                        {category.name}
                      </Label>
                      <p className="text-sm text-muted-foreground mb-2">
                        {category.description}
                      </p>
                      <div className="flex flex-wrap gap-1">
                        {displayScopes.map((scope) => (
                          <Badge key={scope} variant="outline" className="text-xs">
                            {scope}
                          </Badge>
                        ))}
                        {remainingCount > 0 && (
                          <Badge variant="outline" className="text-xs">
                            +{remainingCount} more
                          </Badge>
                        )}
                      </div>
                    </div>
                  </div>
                )
              })}
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
